module.exports = __webpack_public_path__ + "static/media/eye.e7000557.svg";